module.exports = __webpack_public_path__ + "img/chanp@2x.35844dbd.png";